import { render, staticRenderFns } from "./MainLayout.layout.vue?vue&type=template&id=37d0bfd6&scoped=true&"
import script from "./MainLayout.layout.vue?vue&type=script&lang=ts&"
export * from "./MainLayout.layout.vue?vue&type=script&lang=ts&"
import style0 from "./MainLayout.layout.vue?vue&type=style&index=0&id=37d0bfd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d0bfd6",
  null
  
)

export default component.exports